import { _isRTLEnabled } from '@/composables/useDirection.ts'

export default {
    install (Vue) {
        const app = new Vue({
            data () {
                return {
                    isRTL: false
                }
            },
            methods: {
                enableRTL (changeComposable = true) {
                    this.isRTL = true
                    document.body.classList.add('rtl')
                    document.documentElement.dir = 'rtl'

                    if (changeComposable) {
                        _isRTLEnabled.value = true
                    }
                },
                disableRTL (changeComposable = true) {
                    this.isRTL = false
                    document.body.classList.remove('rtl')
                    document.documentElement.dir = 'ltr'

                    if (changeComposable) {
                        _isRTLEnabled.value = false
                    }
                },
                onMessage (event) {
                    if (!event.data || !event.data.type) {
                        return
                    }

                    if (event.data.type === 'direction' && typeof event.data.value === 'string' && [ 'rtl', 'ltr' ].includes(event.data.value)) {
                        if (event.data.value === 'rtl') {
                            this.enableRTL(false)
                        } else {
                            this.disableRTL(false)
                        }
                    }
                }
            },
            created () {
                window.addEventListener(
                    'message',
                    this.onMessage.bind(this),
                )
            },
            beforeUnmount () {
                window.removeEventListener(
                    'message',
                    this.onMessage.bind(this),
                )
            }
        })

        Vue.prototype.$rtl = app
    }
}
